
import userCountry from '~/components/login/userCountry.vue' // 国家
import upload from '~/components/common/upload.vue' // 国家
export default {
  components: { 'user-country': userCountry, upload },
  props: {
    type: {
      // 1加入还是2认领3认证
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      roTade: false,
      firstLoad: true, // 是否为首次加载该组件
      ruleForm: {
        userId: '',
        type: 6,
        userName: '',
        tn: '',
        code: '', // 待定
        name: '',
        email: '',
        content: '',
        contactWays: [
          {
            type: 2,
            areaCode: this.$store.state.usergetCountry.code,
            otherTypeName: '',
            contactWay: ''
          }
        ],
        attachments: []
      },
      // rules: {
      //   companyName: [
      //     { required: true, message: this.$v('请输入您公司的名称'), trigger: 'blur' }
      //   ],
      //   name: [
      //     { required: true, message: this.$v('请输入姓名'), trigger: 'blur' }
      //   ],
      //   email: [
      //     { required: true, message: this.$v('请输入您的邮箱地址'), trigger: 'blur' },
      //     { type: 'email', message: this.$v('请输入正确的邮箱地址'), trigger: ['blur', 'change'] }
      //   ],
      //   'contactWay.phoneNumber': [
      //     { required: true, message: this.$v('请输入手机号'), trigger: 'blur' }
      //   ],
      //   'contactWay.contact': [
      //     { required: true, message: this.$v('请输入其他联系方式'), trigger: 'blur' }
      //   ]
      // },
      contactdata: [
        {
          index: 2,
          text: this.$v('手机'),
          icon: 'icon-hongseshouji-X',
          color: '#52A6EC',
          placetext: this.$v('请输入您的手机号')
        },
        {
          index: 1,
          text: this.$v('微信'),
          icon: 'icon-weixin',
          color: 'rgba(40, 196, 69, 1)',
          placetext: this.$v('请输入你的微信号')
        },
        {
          index: 3,
          text: 'WhatsApp',
          icon: 'icon-whatsapp',
          color: 'rgba(37, 211, 102, 1)',
          placetext: this.$v('请输入您的WhatsApp')
        },
        {
          index: 4,
          text: this.$v('其他'),
          icon: 'icon-ziyuan',
          color: 'rgba(208, 214, 220, 1)',
          placetext: this.$v('请输入您的其他联系方式')
        }
      ],
      prop: 'contactWays[0].contactWay',
      active: 0,
      placeholder: this.$v('请输入您的手机号'),
      image: [],
      countries: this.$store.state.LanguageCode != 'zh-cn' && this.$store.state.LanguageCode != 'zh' && this.$store.state.LanguageCode != 'zh-tw' && this.$store.state.LanguageCode != 'zh-hk' ? require('~/static/json/areaCodeEn.json') : require('~/static/json/areaCodeCN.json') // 中文国家列表
    }
  },
  computed: {
    rules() {
      console.log(this.rulesfn(), 88889)
      return this.rulesfn()
    }
  },
  watch: {
    roTade(newV) {
      // 监听国家下拉框
      if (!newV || !this.firstLoad) return false // 收起或非首次展开下拉框时，不执行后续操作
      this.firstLoad = false // 当首次展开下拉框时，需要执行以下操作，后续无需执行
      this.$nextTick(() => {
        this.$refs.userCountry._scrollInit()
        this.$refs.userCountry.getHeight()
      })
    },
    ruleForm: {
      handler(newValue, oldValue) {
        console.log(newValue, 989)
        // const contactWay = {
        //   type: this.active,
        //   phoneAreaCode: this.$store.state.usergetCountry.code,
        //   contact: newValue.contact
        // }
        // newValue.contactWay = contactWay
        // const obj = Object.assign({}, newValue)
        // console.log(obj, 3333)
        // this.rulesfn()
        newValue.userName = newValue.tn
        this.$emit('contactusform', newValue)
      },
      deep: true
    }
  },
  mounted() {
    document.addEventListener('click', this.coutryClose, { passive: true })
  },
  beforeDestroy() {
    document.removeEventListener('click', this.coutryClose)
  },
  methods: {
    toclaimRule() {
      window.open(`https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/claimRule?type=${this.ruleForm.applicationType}`)
    },
    coutryClose(e) {
      // 点击非组件区域关闭下拉框
      this.roTade = false
    },
    init(d) {
      // 初始化回填数据
      // if (!d.pdi) return
      // const result = d.applicationContent
      // this.ruleForm.companyName = result.companyName
      // this.ruleForm.name = result.userName
      // this.ruleForm.email = result.email
      // this.active = result.type
      // this.ruleForm.contactWay.contact = result.contactWay.contact
      // this.ruleForm.cooperationTargets = result.content
      // this.image = [...result.attachments]
      // this.countries.forEach((item) => {
      //   if (item.code == result.phoneAreaCode) {
      //     this.$store.commit('setuserCountry', item) // 更换点击的国家
      //   }
      // })
      // this.$refs.upload.init(result.attachments)
      // this.onPicChange([...result.attachments])
      // console.log(result, 22213)
    },
    setcompanyName(name) {
      // 设置企业名称
      this.ruleForm.name = name
    },
    setdata(item) {
      // 表单赋值处理赋值
      console.log(item, 333)
      for (const key in item) {
        this.ruleForm[key] = item[key]
      }
    },
    tabcontact(item, index) {
      this.active = index
      this.ruleForm.contactWays[0].type = item.index
      this.placeholder = item.placetext
      this.ruleForm.contactWays[0].contactWay = ''
    },
    onPicChange(arr) {
      this.ruleForm.attachments = JSON.parse(JSON.stringify(arr))
    },
    uploadError(bool) {
      if (bool) {
        this.$Toast.fail({
          message: this.$v('文件大小不能超过 5M'),
          icon: 'none',
          duration: 2000,
          getContainer: '#contactuslog'
        })
      }
    },
    rulesfn() {
      console.log(123, this.active)
      const phonevalidate = (rule, value, callback) => {
        if (this.$store.state.usergetCountry.code == '0086') {
          // 如果为国内则走国内手机号验证
          if (!this.ruleForm.contactWays[0].phoneNumber) {
            // return (this.signin.formatError = this.$v('用户手机号有误'))
            return this.$v('请输入手机号')
          }
          const myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
          if (!myreg.test(this.ruleForm.contactWays[0].phoneNumber)) {
            return this.$v('手机号格式错误')
          }
        } else {
          // 否则走国外手机号验证
          if (!this.ruleForm.contactWays[0].phoneNumber) {
            return this.$v('请输入手机号')
          }
          const myreg = /^.{5,20}$/
          if (!myreg.test(this.ruleForm.contactWays[0].phoneNumber)) {
            return this.$v('手机号格式错误')
          }
        }
      }
      const rulesval = {
        name: [
          {
            required: true,
            message: this.$v('请输入您公司的名称'),
            trigger: 'blur'
          }
        ],
        tn: [{ required: true, message: this.$v('请输入姓名'), trigger: 'blur' }],
        email: [
          {
            required: true,
            message: this.$v('请输入您的邮箱地址'),
            trigger: 'blur'
          },
          {
            type: 'email',
            message: this.$v('请输入正确的邮箱地址'),
            trigger: ['blur', 'change']
          }
        ],
        'contactWays[0].contactWay': [
          {
            required: true,
            message: this.ruleForm.contactWays[0].type == 2 ? phonevalidate() : this.contactdata[this.active].placetext,
            trigger: 'blur'
          }
        ]
      }
      // Object.assign(rulesval, obj)
      console.log(JSON.parse(JSON.stringify(rulesval)), 999, this.prop)
      return JSON.parse(JSON.stringify(rulesval))
    },
    validatefn() {
      console.log(123)
      this.$refs.ruleForm.validate((valid) => {
        console.log('true', valid)
        if (valid) {
          this.$emit('validatefn')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
